import { render, staticRenderFns } from "./TodoDetailsComponent.vue?vue&type=template&id=411566e6&scoped=true&"
import script from "./TodoDetailsComponent.vue?vue&type=script&lang=ts&"
export * from "./TodoDetailsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TodoDetailsComponent.vue?vue&type=style&index=0&id=411566e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411566e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VContainer,VDivider,VRow})
